import React, { useState, useEffect } from 'react';
import '../EvaluacionRiesgoModal.css';

const EvaluacionRiesgoModal2 = ({ siguiente, anterior, onClose, formData, setFormData }) => {
  const [impactoSGSS, setImpactoSGSS] = useState(null);
  const [impactoSocial, setImpactoSocial] = useState(null);

  useEffect(() => {
    setImpactoSGSS(formData.impactoSGSS);
    setImpactoSocial(formData.impactoSocial);
  }, [formData]);

  const sgssOptions = [
    {
      text: `- Número de casos que asisten a servicios es menor o mayor a lo usual.\n- Tratamiento disponible en los primeros niveles de atención.`,
      value: 1,
    },
    {
      text: `- Número de casos que asisten a servicios es menor o mayor a lo usual en zonas no municipalizadas.\n- Tratamiento disponible en los primeros niveles de atención en zonas no municipalizadas.`,
      value: 5,
    },
    {
      text: `- El número de casos desbordan la capacidad instalada para la atención en salud.\n- Tratamiento disponible en el tercer nivel de atención.`,
      value: 15,
    },
    {
      text: `- Tratamiento en hospitales centrales y de IV nivel; no hay tratamiento específico; los hospitales regionales no tienen capacidad.\n- Colapso de los servicios de salud.\n- Afectación de personal de salud.`,
      value: 50,
    },
    ];

  const socialOptions = [
    {
      text:
    `- La zona afectada es rural y es visitada por turistas.\n- El sistema económico no está afectado.`,
    value: 1,
    },
    {
      text:
    `- La zona afectada es un municipio turístico y es capital del departamento.\n- El evento no genera afectación de la convivencia social.`,
    value: 5,
    },
    {
      text:
    `- La zona afectada es un municipio turístico o con alta influencia económica y no es capital del departamento.\n- La afectación es en una zona no municipalizada.\n- Evento que genera afectación de la convivencia social.`,
    value: 15,
    },
    {
      text:
    `- Afectación en más de dos zonas del departamento.\n- Evento que genera alteración de convivencia local con muertes relacionadas.`,
      value: 50,
    },
  ];

  const handleNext = () => {
    setFormData({
      ...formData,
      impactoSGSS,
      impactoSocial
    });
    siguiente();
  };

  const handleBack = () => {
    setFormData({
      ...formData,
      impactoSGSS,
      impactoSocial
    });
    anterior();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3 className="text-center mb-3">EVALUACIÓN DEL RIESGO</h3>    
        <div className="row">
          {/* Impacto sobre el SGSS */}
          <div className="col-md-6">
            <h6>Impacto sobre el SGSS</h6>
            <div className="cuadros-container">
              
{sgssOptions.map((item, index) => (
  <div
    key={index}
    className={`opcion-cuadro ${impactoSGSS === item.value ? 'seleccionado' : ''}`}
    onClick={() => setImpactoSGSS(item.value)}
      >
       <input
         type="radio"
         name="impactoSGSS"
         checked={impactoSGSS === item.value}
           readOnly
          className="mb-2"
           />
           <pre className="opcion-texto">{item.text}</pre>
                </div>
              ))}
            </div>
          </div>

          {/* Impacto social */}
          <div className="col-md-6">
            <h6>Impacto social</h6>
            <div className="cuadros-container">
              {socialOptions.map((item, index) => (
  <div
    key={index}
    className={`opcion-cuadro ${impactoSocial === item.value ? 'seleccionado' : ''}`}
    onClick={() => setImpactoSocial(item.value)}
  >
    <input
      type="radio"
      name="impactoSocial"
      checked={impactoSocial === item.value}
      readOnly
      className="mb-2"
    />
    <pre className="opcion-texto">{item.text}</pre>
  </div>
              ))}
            </div>
          </div>
        </div>

        <div className="text-center mt-4">
          <button className="btn btn-outline-primary me-2" onClick={handleBack}>Anterior</button>
          <button className="btn btn-secondary me-2" onClick={onClose}>Cerrar</button>
          <button
  className="btn btn-primary"
  onClick={handleNext}
  disabled={impactoSGSS === null || impactoSocial === null}
>
  Siguiente
</button>
        </div>
      </div>
    </div>
  );
};

export default EvaluacionRiesgoModal2;
